import { AppSettingEditor } from "../../helper/AppSettingditor";

const AboutUs = () => <AppSettingEditor title="About Us" settingCode="AP-008" pageId={9} />;
export default AboutUs;